import { Box, Card, Slide } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import MDBox from "../../components/MDBox";
import { BASIC_INFO, SECURITY } from "../../config/constants";
import Header from "./components/Header";
import EditBasicInfo from "./components/profileTabContents/EditBasicInfo";
import EditSecurity from "./components/profileTabContents/EditSecurity";

const Profile = () => {

    const { mainProfileTab } = useSelector(state => state.profile);
    const [show, setShow] = useState(false);

    useEffect(() => {
        setShow(true);
        return () => {
            setShow(false);
        }
    }, []);

    const getTabContent = (tab) => {
        switch (tab.label) {
            case BASIC_INFO:
                return <EditBasicInfo />;
            case SECURITY:
                return <EditSecurity />;
            default:
                return (
                    <>
                        This is the profile page
                    </>
                );
        }
    }

    return (
        <Slide in={show} direction="left" style={{ transitionDuration: '500ms' }} >
            <Box sx={{ height: "fit-ccontent" }}>
                <MDBox
                    sx={{
                    }}
                >
                    <Header />

                    {
                        mainProfileTab

                        &&

                        getTabContent(mainProfileTab)
                    }
                </MDBox>
            </Box>
        </Slide>
    );
}

export default Profile;